import VueRouter from 'vue-router';

import Landing from './views/Landing';
import SavePlaylist from './views/SavePlaylist';
import ErrorComponent from './views/Error';
import Testing from './views/Testing';
import Name2 from './views/Name2';
import Answer3 from './views/Answer3';
import Genres4 from './views/Genres4';
import SleepStory5 from './views/SleepStory5';
import Result6 from './views/Result6';

const router = new VueRouter({
	mode: 'history',
	routes: [{
		path: '/',
		component: Landing,
		name: '1'
	},
	{
		path: '/results/listen',
		component: SavePlaylist,
		name: 'savePlaylist',
		props: true
	},
	{
		path: '/2',
		component: Name2,
		name: '2'
	},
	{
		path: '/3',
		component: Answer3,
		name: '3'
	},
	{
		path: '/4',
		component: Genres4,
		name: '4'
	},
	{
		path: '/5',
		component: SleepStory5,
		name: '5'
	},
	{
		path: '/6',
		component: Result6,
		name: '6'
	},
	{
		path: '/error',
		component: ErrorComponent,
		name: 'error'
	},
	{
		path: '/testing',
		component: Testing,
		name: 'testing'
	},
	{
		path: '*',
		redirect: '/'
	}
	],
	scrollBehavior(to, from, savedPosition) {
		return new Promise((resolve, reject) => {
			setTimeout(() => {
				if (savedPosition) {
					resolve(savedPosition);
				} else {
					resolve({ x: 0, y: 0 });
				}
			}, 500);
		});
	}
});

export default router;